/**
 * Money formatting utility - ALWAYS shows 2 decimals
 * NEVER rounds to whole numbers
 */

/**
 * Format a monetary value with exactly 2 decimal places
 * @param {number} value - The numeric value
 * @param {string} currency - Currency code (default: EUR)
 * @returns {string} Formatted price like "€53.78"
 */
export const formatMoney = (value, currency = 'EUR') => {
  if (value === null || value === undefined || isNaN(value)) {
    return '€0.00';
  }
  
  const numValue = parseFloat(value);
  
  // Currency symbols map
  const symbols = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    TRY: '₺',
  };
  
  const symbol = symbols[currency] || '€';
  
  // ALWAYS 2 decimal places - NEVER round to whole number
  return `${symbol}${numValue.toFixed(2)}`;
};

/**
 * Format price for display - same as formatMoney but returns object
 * @param {number} value 
 * @param {string} currency 
 * @returns {{ formatted: string, value: number, symbol: string }}
 */
export const formatPrice = (value, currency = 'EUR') => {
  const numValue = parseFloat(value) || 0;
  const symbols = { EUR: '€', USD: '$', GBP: '£', TRY: '₺' };
  const symbol = symbols[currency] || '€';
  
  return {
    formatted: `${symbol}${numValue.toFixed(2)}`,
    value: numValue,
    symbol,
  };
};

/**
 * Calculate and validate total
 * Logs error if computed total differs from expected by more than 0.01
 * @param {number} tripPrice 
 * @param {number} extrasPrice 
 * @param {number} expectedTotal 
 * @returns {number} The computed total (2 decimal precision)
 */
export const calculateTotal = (tripPrice = 0, extrasPrice = 0, expectedTotal = null) => {
  const trip = parseFloat(tripPrice) || 0;
  const extras = parseFloat(extrasPrice) || 0;
  const computed = Math.round((trip + extras) * 100) / 100; // Round to 2 decimals
  
  if (expectedTotal !== null) {
    const expected = parseFloat(expectedTotal);
    if (Math.abs(computed - expected) > 0.01) {
      console.error('[PriceMismatch] Computed total differs from expected:', {
        trip,
        extras,
        computed,
        expected,
        diff: Math.abs(computed - expected),
      });
    }
  }
  
  return computed;
};

export default formatMoney;
